import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M2.992,2.424l18.515,0c0.481,0 0.747,0.65 0.447,1.088l-7.402,10.812c-0.078,0.115 -0.123,0.256 -0.125,0.404l-0.071,3.895c-0.004,0.223 -0.103,0.428 -0.262,0.549l-3.415,2.578c-0.38,0.286 -0.883,-0.033 -0.883,-0.563l0,-6.403c0,-0.16 -0.049,-0.315 -0.138,-0.437l-7.101,-10.817c-0.319,-0.434 -0.056,-1.107 0.434,-1.107Z",
		style: {
			fill: "none",
			fillRule: "nonzero",
			stroke: "currentColor",
			strokeWidth: "1.5px"
		}
	}) })
});
export default SvgFilter;
